import React from 'react'
import { Row, Col } from 'react-bootstrap'

const OrderStatus = ({ workingStatus, onClick }) => {
  return (
    <Row>
      <Col>
        <div className="d-flex justify-content-between">
          <div className="d-flex pb-2">
            <div className="btn-group  mx-2">
              <div
                className={workingStatus === 'pending' ? 'btn btn-warning' : 'btn btn-outline-warning'}
                onClick={() => onClick({ color: 'bg-warning', message: 'รอชำระเงิน', status: 'pending' })}
              >
                รอชำระเงิน
              </div>
              <div
                className={workingStatus === 'receipt attached' ? 'btn btn-info' : 'btn btn-outline-info'}
                onClick={() => onClick({ color: 'bg-info', message: 'แนบสลิปแล้ว', status: 'receipt attached' })}
              >
                แนบสลิปแล้ว
              </div>
              <div
                className={workingStatus === 'success' ? 'btn btn-success' : 'btn btn-outline-success'}
                onClick={() => onClick({ color: 'bg-success', message: 'ซื้อสำเร็จ', status: 'success' })}
              >
                ซื้อสำเร็จ
              </div>
              <div
                className={workingStatus === 'cancelled' ? 'btn btn-danger' : 'btn btn-outline-danger'}
                onClick={() => onClick({ color: 'bg-danger', message: 'ยกเลิก', status: 'cancelled' })}
              >
                ยกเลิก
              </div>
              <div
                className={workingStatus === 'processing' ? 'btn btn-secondary' : 'btn btn-outline-secondary'}
                onClick={() =>
                  onClick({ color: 'bg-secondary', message: 'กำลังดำเนินการจัดส่ง', status: 'processing' })
                }
              >
                กำลังดำเนินการจัดส่ง
              </div>
            </div>

            <div className="btn-group ms-2 mx-2">
              <div
                className={workingStatus === 'random' ? 'btn btn-red ' : 'btn btn-outline-red '}
                onClick={() => onClick({ color: 'bg-red', message: 'เสื้อจากกล่องสุ่ม', status: 'random' })}
              >
                เสื้อจากกล่องสุ่ม
              </div>
            </div>
            {workingStatus != 'random' && (
              <div className={workingStatus === 'search' ? 'btn btn-primary' : 'btn btn-outline-primary'}>ค้นหา</div>
            )}
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default OrderStatus
